import { render } from "./SGOverview.vue?vue&type=template&id=ee8f1ed0&scoped=true"
import script from "./SGOverview.vue?vue&type=script&lang=js"
export * from "./SGOverview.vue?vue&type=script&lang=js"

import "./SGOverview.vue?vue&type=style&index=0&id=ee8f1ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8f1ed0"]])

export default __exports__